export default {
  none: 0,
  positive: 1,
  negative: 2
}
